import type { ReactNode } from "react";
import { cx } from "./cx";

export interface TabItem {
  value: string;
  label: ReactNode;
}

export interface TabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/** Underlined tabs: the gold 3px underline marks the active one, the only gold rule in navigation. */
export function Tabs({ tabs, value, onChange, className }: TabsProps) {
  return (
    <div role="tablist" className={cx("flex gap-6 border-b border-border-default", className)}>
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={cx(
              "-mb-px inline-flex cursor-pointer items-center gap-2 border-b-[3px] bg-transparent px-0 pb-3 type-h4 [font-size:var(--text-base)] [transition:var(--transition-control)]",
              active ? "border-gold-500 text-text-strong" : "border-transparent text-text-muted hover:text-green-800",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
